import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FidelidadeEmail } from 'src/app/models/fidelidade-email';
import { Segmentacao } from 'src/app/models/segmentacao';
import { TemplateEmail } from 'src/app/models/template-email';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FidelidadeEmailService } from 'src/app/services/fidelidade-email.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { TemplateEmailService } from 'src/app/services/template-email.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-fidelidade-email',
  templateUrl: './cadastrar-fidelidade-email.component.html',
  styleUrls: ['./cadastrar-fidelidade-email.component.scss'],
})
export class CadastrarFidelidadeEmailComponent implements OnInit {
  email: FidelidadeEmail;

  tipos = [
    { id: 0, descricao: 'Go+ Boas Vindas' },
    { id: 1, descricao: 'Go+ Alerta Categoria' },
    { id: 2, descricao: 'Go+ Extrato Mensal' },
  ];

  classificacoes: Segmentacao[] = [];
  templatesEmail: TemplateEmail[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private fidelidadeEmailService: FidelidadeEmailService,
    private templateEmailService: TemplateEmailService,
    private segmentacaoService: SegmentacaoService,
    public dialogRef: MatDialogRef<CadastrarFidelidadeEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (this.data) {
      this.email = this.data.email;
    } else {
      this.email = new FidelidadeEmail();
    }
  }

  buscarClassificacao() {
    this.carregandoService.mostra('buscarClassificacao');

    this.segmentacaoService.consultar().subscribe(
      (dados) => {
        this.classificacoes = dados;
        this.carregandoService.esconde('buscarClassificacao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarClassificacao');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarTemplatesEmail() {
    this.carregandoService.mostra('buscarTemplatesEmail');

    this.templateEmailService.consultarTemplates().subscribe(
      (dados) => {
        this.templatesEmail = dados;
        this.carregandoService.esconde('buscarTemplatesEmail');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTemplatesEmail');
        this.notificacaoService.erro(erro);
      },
    );
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.fidelidadeEmailService.salvar(this.email).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.dialogRef.close(this.email);
      },
      (err) => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      },
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.buscarClassificacao();
    this.buscarTemplatesEmail();
  }
}
